export default {
  getTiptapContent: (state) => ({ language, page }) => state.pageContent[language]?.[page] || false,
};
